import { render, staticRenderFns } from "./content_txt.vue?vue&type=template&id=6811c3f4&scoped=true&"
import script from "./content_txt.vue?vue&type=script&lang=js&"
export * from "./content_txt.vue?vue&type=script&lang=js&"
import style0 from "./content_txt.vue?vue&type=style&index=0&id=6811c3f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6811c3f4",
  null
  
)

export default component.exports